export default "__VITE_ASSET__CrnOS1oG__"